module.exports = __webpack_public_path__ + "static/media/buyBg2.e29a3167.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/buyBg2.png
// module id = 417
// module chunks = 0